import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  PageHeader,
  PageReturn,
  PageTitle,
  H1,
  ContentStatus,
  PageDescription,
  PageSubheader,
  PageActions,
  Button,
  ListRow,
  MenuSection,
  MoreMenu,
} from 'next/components/ui';
import { format } from 'next/lib/date';
import { selectAccountUser } from 'next/entities/account-users';
import { selectExperience } from 'next/entities/experiences';
import PlatformBadge from './PlatformBadge';

export function Header({
  appId,
  id,
  name,
  state,
  published,
  createdAt,
  createdByName,
  updatedAt,
  updatedByName,
}) {
  return (
    <PageHeader>
      <PageDescription>
        <PageTitle>
          <PageReturn to={`/flows/mobile/${id}/analytics`} />
          <H1>{name}</H1>
          <ContentStatus state={state} published={published} />
          <PlatformBadge appId={appId} />
        </PageTitle>
        <PageSubheader>
          Created by {createdByName} on {format(createdAt, 'MMM D, YYYY')}{' '}
          {updatedAt &&
            `| Last updated by ${updatedByName} on ${format(
              updatedAt,
              'MMM D, YYYY'
            )}`}
        </PageSubheader>
      </PageDescription>
      <PageActions>
        <Button aria-label="Publish">Publish</Button>
        <MoreMenu>
          <MenuSection>
            <ListRow>Open in Builder</ListRow>
            <ListRow>View preview options</ListRow>
            {state === 'PUBLISHED' && <ListRow>Open permalink options</ListRow>}
          </MenuSection>
        </MoreMenu>
      </PageActions>
    </PageHeader>
  );
}

Header.propTypes = {
  appId: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  state: PropTypes.oneOf(['DRAFT', 'PUBLISHED', 'ARCHIVED']),
  published: PropTypes.bool,
  createdAt: PropTypes.number,
  createdByName: PropTypes.string,
  updatedAt: PropTypes.number,
  updatedByName: PropTypes.string,
};

const mapStateToProps = (state, { id }) => {
  const {
    appId,
    published,
    state: experienceState,
    updatedAt,
    updatedBy,
    createdAt,
    createdBy,
    name,
    previewUrl,
  } = selectExperience(state, id);
  const createdByUser = selectAccountUser(state, createdBy);
  const updatedByUser = selectAccountUser(state, updatedBy);

  return {
    appId,
    id,
    name,
    state: experienceState,
    published,
    createdAt,
    createdByName: createdByUser?.fullname ?? createdBy,
    updatedAt,
    updatedByName: updatedByUser?.fullname ?? updatedBy,
    previewUrl,
  };
};

export default connect(mapStateToProps)(Header);
